module.exports = __webpack_public_path__ + "static/media/Checkmark.11b47946.svg";